import actions from "./actions";

const {
    FETCH_ACADEMIC_TRANSCRIPT_REPORT,
    FETCH_SINGLE_STUDENT_ACADEMIC_TRANSCRIPT,
    FETCH_ACADEMIC_TRANSCRIPT_RESET,
} = actions;

const initState = {
    academicTranscriptReport: [],
    singleStudentTranscript: null,
};

const AcademicTranscriptReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_ACADEMIC_TRANSCRIPT_REPORT:
            return {
                ...state,
                academicTranscriptReport: data,
            };
        case FETCH_SINGLE_STUDENT_ACADEMIC_TRANSCRIPT:
            return {
                ...state,
                singleStudentTranscript: data,
            };
        case FETCH_ACADEMIC_TRANSCRIPT_RESET:
            return {
                ...state,
                academicTranscriptReport: initState.academicTranscriptReport,
                singleStudentTranscript: initState.singleStudentTranscript,
            };
        default:
            return state;
    }
};

export default AcademicTranscriptReducer;